"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var __1 = require("..");

exports.getActions = function (dispatch) {
  return {
    invalidateCache: function invalidateCache(endpointKey, params, instanceId) {
      if (instanceId === void 0) {
        instanceId = '';
      }

      return dispatch(__1.invalidateApiDataRequest(endpointKey, params, instanceId));
    },
    perform: function perform(endpointKey, params, body, instanceId) {
      if (instanceId === void 0) {
        instanceId = '';
      }

      return dispatch(__1.performApiRequest(endpointKey, params, body, instanceId));
    }
  };
};